// lib/firebase.ts
import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyCOZz0rH8Ty14Tv6-y0rtZKjnDB4JMubGU",
  authDomain: "svevana-push.firebaseapp.com",
  projectId: "svevana-push",
  storageBucket: "svevana-push.appspot.com",
  messagingSenderId: "71980799135",
  appId: "1:71980799135:web:b0ad0c43ba77d506027eaa",
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export { messaging };
